import { TourModel } from 'api-hooks/tour/tour-list/tour-detail';
import { AuthorizationRules } from 'common/constants';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer, { DrawerProvider } from 'hooks/use-drawer';
import OtherIncomeList from 'legacy-modules/other-income/list';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useTourIncomeAction(tour: TourModel) {
  const { t } = useTranslation();
  const { can } = useAuthorization();
  const drawer = useDrawer();
  const id = tour.id;

  const tourIncomePermission = can(AuthorizationRules.ToursGetOtherIncomes);

  const onGetTourIncome = React.useCallback(() => {
    drawer.showCustom({
      render: (onClose) => (
        <DrawerProvider>
          <OtherIncomeList type="Tour" data={tour} onClose={onClose} />
        </DrawerProvider>
      ),
    });
  }, [drawer, tour]);

  const tourIncomeAction: PopoverMenuType = {
    key: `tour-income-${id}`,
    label: t('common:other_incomes'),
    onClick: onGetTourIncome,
    isAllowed: tourIncomePermission,
  };

  return {
    tourIncomePermission,
    tourIncomeAction,
  };
}
